import React, { Component } from 'react'
import classnames from 'classnames'
import Config from '../../../Config'
import { Col, Row } from 'react-flexbox-grid'
import { localize } from '../../../util/Localizer'
import RBButton from '../../../controls/RBButton'
import Card from '@material-ui/core/Card'
import Icon from '@material-ui/core/Icon'
import RBSelectField from '../../../controls/RBSelectField'
import Loading from '../../../widgets/Loading'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { fetchPension } from '../../../redux/actions/memberSummaryActions'

class PensionStatements extends Component {
  constructor () {
    super()
    this.downloadResource = this.downloadResource.bind(this)
    this.state = {
      open: false,
      year: '2019'
    }
  }

  downloadResource () {
    const { pension = {} } = this.props
    const { annualStatements = [] } = pension
    const download = annualStatements.find((e) => {
      return e.year === this.state.year
    })// im coming back to this tony but it didnt work
    const url = `${download.url}`.replace('/api/v1', '')
    const link = `${Config.apiUrl}${url}`
    window.open(link)
  }

  render () {
    const { classes = {}, pension = {} } = this.props
    const { annualStatements = [] } = pension
    const selects = []
    annualStatements.forEach((e) => {
      selects.push(e.year)
    })
    return (
      <div>
        <h4 className='sectionHeading'>{localize('pages.pension.pensionStatements')}</h4>
        {this.props.pensionIsLoading
          ? <Loading/>
          : <Row>
            <Col xs={12} sm={8} md={6} lg={4}>
              <RBSelectField
                id='period'
                label={'Period'}
                fullWidth
                selected={this.state.year}
                sendValues={(e) => { this.setState({ year: e.textValue, file: e.file, url: e.url }) }}
                data={selects}
              />
            </Col>
          </Row>}
        {this.props.pensionIsLoading ? null
          : <Card className={classnames(classes.summaryCard, classes.baseCard)} style={{ padding: 20 }}>
            <Row>
              <Col xs={12} md={8} lg={6}>
                <RBButton
                  className={classes.resourcesButton}
                  label={`${this.state.year} ${localize('pages.pension.pensionStatements.statementTitle')}`}
                  variant='outlined'
                  fullWidth
                  labelPosition='before'
                  styles={{ justifyContent: 'start' }}
                  onClick={this.downloadResource}
                  disabled={!!this.state.file}
                  icon={<Icon className={classes.borderedIcon}>arrow_downward</Icon>}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={8} lg={6}>
                <p>{localize('pages.pension.pensionStatements.contactOEBAC')}</p>
              </Col>
            </Row>
          </Card>}
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    pension: state.memberSummaryReducer.pension || {},
    pensionIsLoading: state.memberSummaryReducer.pensionIsLoading
  }
}

const ConnectedPensionStatements = connect(mapStateToProps, { fetchPension })(injectIntl(PensionStatements))

export default (ConnectedPensionStatements)



// WEBPACK FOOTER //
// ./src/widgets/Member/pensionWidgets/PensionStatements.js